import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["confirmModal"];

  show(e) {
    e.preventDefault();
    this.confirmModalTarget.classList.remove("hidden");
  }

  close(e) {
    e.preventDefault();
    this.confirmModalTarget.classList.add("hidden");
  }
}
